import { getTeamColorStyle } from '../utils/colorUtils';

interface PossessionArrowProps {
  possession: 'home' | 'away' | null;
  homeColor: string;
  awayColor: string;
}

export function PossessionArrow({ possession, homeColor, awayColor }: PossessionArrowProps) {
  if (!possession) return null;

  const isHome = possession === 'home';
  const color = isHome ? homeColor : awayColor;
  const style = getTeamColorStyle(color);

  return (
    <div className="flex items-center justify-center">
      <div
        className="flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold"
        style={{
          backgroundColor: style.backgroundColor,
          color: style.color,
          border: style.border,
        }}
      >
        {isHome ? (
          <>
            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
            <span>POSS</span>
          </>
        ) : (
          <>
            <span>POSS</span>
            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </>
        )}
      </div>
    </div>
  );
}
